document.addEventListener('DOMContentLoaded', function () {
  function moneyFormat(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  function getProductData(form) {
    var container =
      form.closest('product-info') ||
      form.closest('.product') ||
      form.closest('.shopify-section') ||
      document;

    if (window.__product && window.__product.variants) return window.__product;

    var jsonEl =
      container.querySelector('script[type="application/json"][data-product-json]') ||
      container.querySelector('product-info script[type="application/json"]') ||
      container.querySelector('.product script[type="application/json"]');

    if (!jsonEl) return null;

    try {
      return JSON.parse(jsonEl.textContent);
    } catch (e) {
      return null;
    }
  }

  function getSelectedOptions(form) {
    var options = [];

    var fieldsets = form.querySelectorAll('fieldset.product-form__input');
    fieldsets.forEach(function (fieldset) {
      var checked = fieldset.querySelector('input[type="radio"]:checked');
      if (checked) options.push(checked.value.trim());
    });

    var selects = form.querySelectorAll('select[name^="options["]');
    selects.forEach(function (select) {
      options.push(select.value.trim());
    });

    return options;
  }

  function findMatchingVariant(product, selectedOptions) {
    if (!product || !product.variants) return null;

    return product.variants.find(function (variant) {
      var variantOptions = (variant.options || []).map(function (opt) {
        return String(opt).trim();
      });

      if (variantOptions.length !== selectedOptions.length) return false;

      return variantOptions.every(function (opt, i) {
        return opt === selectedOptions[i];
      });
    }) || null;
  }

  function getCurrentVariantFromInput(form, product) {
    var idInput = form.querySelector('input[name="id"]');
    if (!idInput || !product || !product.variants) return null;

    var id = String(idInput.value);
    return product.variants.find(function (v) {
      return String(v.id) === id;
    }) || null;
  }

  function updateMainPrice(form, variant) {
    if (!variant) return;

    var container =
      form.closest('product-info') ||
      form.closest('.product') ||
      form.closest('.shopify-section') ||
      document;

    var regularEls = container.querySelectorAll(
      '.price-item--regular, .price__regular .price-item, .price .price-item, .product__info-container .price-item'
    );

    regularEls.forEach(function (el) {
      if (!el.closest('.price__sale')) {
        el.textContent = moneyFormat(variant.price);
      }
    });

    var saleEls = container.querySelectorAll(
      '.price-item--sale, .price__sale .price-item'
    );

    saleEls.forEach(function (el) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        el.textContent = moneyFormat(variant.compare_at_price);
        el.style.display = '';
      } else {
        el.style.display = 'none';
      }
    });
  }

  function updateButtonPrice(button, variant) {
    if (!button || !variant) return;

    var textWrapper =
      button.querySelector('.main-atc-text') ||
      button.querySelector('span:not(.dynamic-price):not(.btn-icon)');

    if (!textWrapper) return;

    textWrapper.classList.add('main-atc-text');
    textWrapper.textContent = 'Add to bag';

    var dynamicPrice = button.querySelector('.dynamic-price');

    if (!dynamicPrice) {
      dynamicPrice = document.createElement('span');
      dynamicPrice.className = 'dynamic-price';
      dynamicPrice.style.marginLeft = '0.35em';
      textWrapper.insertAdjacentElement('afterend', dynamicPrice);
    }

    dynamicPrice.textContent = ' — ' + moneyFormat(variant.price);
  }

  function updateHiddenVariantInput(form, variant) {
    if (!form || !variant) return;

    var idInput = form.querySelector('input[name="id"]');
    if (idInput && String(idInput.value) !== String(variant.id)) {
      idInput.value = variant.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function updateAvailability(button, variant) {
    if (!button || !variant) return;

    if (variant.available) {
      button.disabled = false;
      button.classList.remove('disabled');
    } else {
      button.disabled = true;
      button.classList.add('disabled');
    }
  }

  function updateEverything() {
    var form =
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('.product-form form') ||
      document.querySelector('product-form form');

    if (!form) return;

    var button =
      form.querySelector('button[type="submit"]') ||
      document.querySelector('button.product-form__submit');

    if (!button) return;

    var product = getProductData(form);
    if (!product) return;

    var selectedOptions = getSelectedOptions(form);
    var variant = null;

    if (selectedOptions.length) {
      variant = findMatchingVariant(product, selectedOptions);
    }

    if (!variant) {
      variant = getCurrentVariantFromInput(form, product);
    }

    if (!variant) {
      variant = product.selected_or_first_available_variant || product.variants[0];
    }

    if (!variant) return;

    updateHiddenVariantInput(form, variant);
    updateMainPrice(form, variant);
    updateButtonPrice(button, variant);
    updateAvailability(button, variant);
  }

  document.addEventListener('change', function (e) {
    if (
      e.target.matches('input[type="radio"]') ||
      e.target.matches('select[name^="options["]') ||
      e.target.matches('input[name="id"]')
    ) {
      setTimeout(updateEverything, 50);
      setTimeout(updateEverything, 150);
    }
  });

  document.addEventListener('variant:change', function () {
    setTimeout(updateEverything, 50);
    setTimeout(updateEverything, 150);
  });

  setTimeout(updateEverything, 100);
  setTimeout(updateEverything, 500);
});